// src/components/LoadMoreButton.jsx

import React from "react";

const LoadMoreButton = ({
  loading,
  hasMore,
  rateLimit,
  isBackoff,
  loadMoreRepos,
}) => {
  if (!hasMore) return null;

  return (
    <div className="text-center mt-8">
      <button
        type="button"
        className={`bg-blue-500 text-white p-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${
          loading || rateLimit.remaining === 0 || isBackoff
            ? "opacity-50 cursor-not-allowed"
            : "hover:bg-blue-600"
        }`}
        onClick={loadMoreRepos}
        disabled={loading || rateLimit.remaining === 0 || isBackoff}
        aria-label="Load more projects"
      >
        {loading ? "Loading more projects..." : "Load More Projects"}
      </button>
    </div>
  );
};

export default LoadMoreButton;
